var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-container"},[_vm._v(" Register How ")])}
var staticRenderFns = []

export { render, staticRenderFns }